module.exports = __webpack_public_path__ + "static/img/activity_sdy_07-1.6efe5a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_07-1.jpg
// module id = GddK
// module chunks = 0